const dealerHeaders = [
  "Dealer_Code",
  "Dealer_Name",
  "Dealer_Category",
  "Beat_Code",
  "Beat_Name",
  "MDD_Code",
  "MDD_Name",
  "TSE_Code",
  "TSE_Name",
  "SO_Code",
  "SO_Name",
  "SMD_Code",
  "SMD_Name",
  "ASM_Code",
  "ASM_Name",
  "ACC_ASM_Code",
  "ACC_ASM_Name",
  "ZM_Code",
  "ZM_Name",
  "ACC_ZM_Code",
  "ACC_ZM_Name",
  "SH_Code",
  "SH_Name",
  "BM_Code",
  "BM_Name",
  "ABM_Code",
  "ABM_Name",
  "ZSM_Code",
  "ZSM_Name",
  "ASE_Code",
  "ASE_Name",
  "ZSE_Code",
  "ZSE_Name",
  "RM_Code",
  "RM_Name",
  "RSM_Code",
  "RSM_Name",
  "RSO_Code",
  "RSO_Name",
  "DAM_CODE",
  "DAM_NAME",
  "SSS_CODE",
  "SSS_NAME",
  "RASM_CODE",
  "RASM_NAME",
  "Master_Latitude",
  "Master_Longitude"
];

export default dealerHeaders;
